import { Component, Input, SimpleChanges } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-aul-002-24",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./aul-002-24.component.html",
  styleUrl: "./aul-002-24.component.scss",
})
export class Aul00224Component {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      const updatedAddressInfo = this.transformPolicyData(
        changes["policyDetails"].currentValue?.aul_002_24
      );
      const transformedData = {
        ...changes["policyDetails"].currentValue?.aul_002_24,
        addressInfo: updatedAddressInfo,
      };
      this.policyDetails = transformedData;
    }
  }

  transformPolicyData(policyData: any): any[] {
    return policyData?.addresses?.map((address: any) => {
      const buildings = policyData.buildings?.filter(
        (b: any) => b.policyAddressId === address.addressId
      ) || [];
      const additionalStructures = policyData.additionalStructures?.filter(
        (as: any) => as.policyAddressId === address.addressId
      ) || [];
      const lossPayeeAddress = policyData.lossPayeeAddress || [];
  
      const lossPayeesWithBuilding = lossPayeeAddress.reduce((acc: any[], lp: any) => {
        if (lp?.premisesBuildingCount) {
          for (const buildingId in lp.premisesBuildingCount) {
            if (lp.premisesBuildingCount.hasOwnProperty(buildingId)) {
              const buildingNumber = lp.premisesBuildingCount[buildingId];
              const buildingInfo = buildings.find(
                (b: any) => b.buildingId === parseInt(buildingId, 10)
              );
              acc.push({
                lossPayee: lp,
                buildingNumber: buildingNumber,
                buildingInfo: buildingInfo,
              });
            }
          }
        } else {
          acc.push({ lossPayee: lp, buildingNumber: null, buildingInfo: null }); // Handle cases without premisesBuildingCount
        }
        return acc;
      }, []);
  
      return {
        ...address,
        buildings,
        additionalStructures,
        lossPayeesWithBuilding: lossPayeesWithBuilding.filter((lpb: { buildingInfo: { policyAddressId: any; }; }) => lpb.buildingInfo?.policyAddressId === address.addressId),
      };
    }) || [];
  }
}
